<div class="container-invalid-form-modal">
    <h2>Opa! Algo deu errado</h2>
    <h3>Dá uma olhadinha nesses campos:</h3>
    <div class="container-list-invalid-form-modal">
        <!-- <ul>
            <li *ngFor="let item of list">{{item}}</li>
        </ul> -->
        <p>{{ stringItems }}</p>
    </div>
    <div class="container-button-invalid-form-modal">
        <button type="button" class="button-invalid-form-modal-styled button-invalid-form-modal" (click)="closeDialog()">Entendi</button>
    </div>
</div>



